import React, { useMemo, useState } from 'react'
import NewsCard, { CATEGORIES, categoryOf } from '../utils/NewsCard'
import PageHero from '../utils/PageHero'
import news from '../data/news.json'

const yearOf = (date = '') => {
  const m = date.match(/\d{4}/)
  return m ? m[0] : 'Earlier'
}

const NewsScreen = () => {
  const [category, setCategory] = useState('All')
  const latestFirst = useMemo(() => [...news].reverse(), [])

  const counts = useMemo(() => {
    const c = { All: latestFirst.length }
    latestFirst.forEach((n) => {
      const k = categoryOf(n.type)
      c[k] = (c[k] || 0) + 1
    })
    return c
  }, [latestFirst])

  const byYear = useMemo(() => {
    const groups = {}
    latestFirst
      .filter((n) => category === 'All' || categoryOf(n.type) === category)
      .forEach((n) => {
        const y = yearOf(n.date)
        ;(groups[y] = groups[y] || []).push(n)
      })
    return Object.keys(groups)
      .sort((a, b) => (a === 'Earlier' ? 1 : b === 'Earlier' ? -1 : b - a))
      .map((year) => ({ year, items: groups[year] }))
  }, [category, latestFirst])

  return (
    <div>
      <PageHero
        eyebrow='Updates'
        title='News'
        description='Research breakthroughs, publications, awards and milestones from the SPEED Lab.'
      />
      <div className='container-wide page-body' style={{ paddingTop: 0 }}>
        <div className='pub-toolbar'>
          <div className='chip-group'>
            {['All', ...Object.keys(CATEGORIES)]
              .filter((c) => counts[c])
              .map((c) => (
                <button
                  key={c}
                  className={`chip ${category === c ? 'is-active' : ''}`}
                  onClick={() => setCategory(c)}
                >
                  {c}
                  <span>{counts[c]}</span>
                </button>
              ))}
          </div>
        </div>

        {byYear.map(({ year, items }) => (
          <section className='pub-year' key={year}>
            <div className='pub-year__label'>{year}</div>
            <div className='news-list'>
              {items.map((n, i) => (
                <NewsCard key={`${n.id}-${i}`} {...n} />
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  )
}

export default NewsScreen
